// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--primary-color:#2b6af8;--primary-color-rgb:43,106,248;--primary-color-dark:#131333;--anny-color:#336;--primary-color-hover:#447bf9;--primary-color-overlay:rgba(68,123,249,.12);--secondary-color:#ff9814;--secondary-color-hover:#ffa32e;--secondary-color-dark:#fa8c00;--secondary-color-overlay:rgba(255,152,20,.8);--success-color:#1bc98e;--success-color-rgb:27,201,142;--success-color-overlay:rgba(27,201,142,.25);--success-color-light:#1edf9e;--info-color:#00dbcb;--info-color-overlay:rgba(0,219,203,.12);--danger-color:#e64759;--danger-color-rgb:230,71,89;--danger-color-light:#e95d6d;--danger-color-overlay:rgba(230,71,89,.25);--warning-color:#e2a04f;--warning-color-rgb:226,160,79;--warning-color-overlay:rgba(226,160,79,.25);--alternate-primary-color:#8a3aff;--light-color:#d8d8d8;--light-color-overlay:hsla(0,0%,85%,.25);--dark-color:#cbcbcb;--text-primary-color:#414141;--text-secondary-color:#5a5a5a;--text-tertiary-color:#9d9d9d;--primary-background:#f3f4f6;--primary-background-dark:#f2f3f6;--primary-background-rgb:243,244,246;--panel-background:#fff;--panel-background-rgb:255,255,255;--panel-background-light:#fff;--panel-background-overlay:hsla(0,0%,100%,.25);--panel-background-overlay-dense:hsla(0,0%,100%,.85);--panel-background-dark:#e3e5ea;--input-background:#e3e5ea;--hover-background:#cccfd9;--sidebar-background:#f3f4f6;--heatmap-background:hsla(0,0%,100%,0);--topbar-background:#f3f3f3;--topbar-background-rgb:243,243,243;--feature-background-normal:#fefefe;--feature-background-colored:#132739;--feature-text-normal:#414141;--feature-text-normal-accent:#ff9814;--feature-text-colored:#fefefe;--feature-text-colored-accent:#ff9814;--table-border-color:#e1e7e8;--light-border-color:#e2e2e2;--dark-border-color:#c4c4c4;--panel-shadow:none;--hover-shadow:0px 5px 25px 0px hsla(0,0%,72%,.7);--dropdown-shadow:0px 4px 8px 0px rgba(97,97,97,.25);--detail-shadow:0px 3px 6px 0px hsla(0,0%,75%,.4);--minimal-shadow:0px 1px 2px 0px hsla(0,0%,75%,.5);--primary-color-shadow:rgba(43,106,248,.5);--secondary-color-shadow:rgba(255,152,20,.5);--success-color-shadow:rgba(27,201,142,.5);--danger-color-shadow:rgba(230,71,89,.5);--warning-color-shadow:rgba(226,160,79,.5);--hero-gradient-start:#e5e5f3;--hero-gradient-end:#f5edea}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": "#2b6af8",
	"primaryColorRgb": "43,106,248",
	"annyColor": "#336",
	"primaryColorDark": "#131333",
	"primaryColorHover": "#447bf9",
	"primaryColorOverlay": "rgba(68,123,249,.12)",
	"secondaryColor": "#ff9814",
	"successColor": "#1bc98e",
	"successColorRgb": "27,201,142",
	"successColorOverlay": "rgba(27,201,142,.25)",
	"successColorLight": "#1edf9e",
	"infoColor": "#00dbcb",
	"infoColorOverlay": "rgba(0,219,203,.12)",
	"dangerColor": "#e64759",
	"dangerColorRgb": "230,71,89",
	"dangerColorOverlay": "rgba(230,71,89,.25)",
	"dangerColorLight": "#e95d6d",
	"warningColor": "#e2a04f",
	"warningColorRgb": "226,160,79",
	"warningColorOverlay": "rgba(226,160,79,.25)",
	"lightColor": "#d8d8d8",
	"lightColorOverlay": "hsla(0,0%,85%,.25)",
	"darkColor": "#cbcbcb",
	"textPrimaryColor": "#414141",
	"textSecondaryColor": "#5a5a5a",
	"textTertiaryColor": "#9d9d9d",
	"primaryBackground": "#f3f4f6",
	"primaryBackground-rgb": "243,244,246",
	"panelBackground": "#fff",
	"panelBackgroundRgb": "255,255,255",
	"panelBackgroundLight": "#fff",
	"panelBackgroundOverlay": "hsla(0,0%,100%,.25)",
	"panelBackgroundOverlayDense": "hsla(0,0%,100%,.85)",
	"panelBackgroundDark": "#e3e5ea",
	"inputBackground": "#e3e5ea",
	"hoverBackground": "#cccfd9",
	"sidebarBackground": "#f3f4f6",
	"heatmapBackground": "hsla(0,0%,100%,0)",
	"topbarBackground": "#f3f3f3",
	"tableBorderColor": "#e1e7e8",
	"lightBorderColor": "#e2e2e2",
	"panelShadow": "none",
	"hoverShadow": "0 5px 25px 0 hsla(0,0%,72%,.7)",
	"dropdownShadow": "0 4px 8px 0 rgba(97,97,97,.25)",
	"detailShadow": "0 3px 6px 0 hsla(0,0%,75%,.4)",
	"minimalShadow": "0 1px 2px 0 hsla(0,0%,75%,.5)",
	"heroGradientStart": "#e5e5f3",
	"heroGradientEnd": "#f5edea",
	"colorPalette": "#5fbbd0,#5b8fdd,#8e5dca,#d33e8a,#e7445e,#ed8047,#f8b52c,#eded5d,#9aed63"
};
module.exports = ___CSS_LOADER_EXPORT___;
